// extracted by mini-css-extract-plugin
module.exports = {"diceContainer":"Dice_diceContainer__1HuxB","dice":"Dice_dice__1jYfH"};